import { SkuQuantity } from '@/components/blocks/FreeGiftV2/types';
import { Dispatch, SetStateAction, createContext, useContext } from 'react';

export interface FreeGiftInteractionContextValue {
	isRewardView: boolean;
	openDrawer: boolean;
	handleOpenDrawer: () => void;
	handleCloseDrawer: () => void;
	isPromotionComplete: boolean;
	setIsPromotionComplete: Dispatch<SetStateAction<boolean>>;
	hasAddedToCart: boolean;
	setHasAddedToCart: Dispatch<SetStateAction<boolean>>;
	promotionQty: number;
	setPromotionQty: Dispatch<SetStateAction<number>>;
	selectedPurchaseGroupId?: string;
	setSelectedPurchaseGroupId: Dispatch<SetStateAction<string | undefined>>;
	selectedPurchaseSkus: SkuQuantity[];
	setSelectedPurchaseSkus: Dispatch<SetStateAction<SkuQuantity[]>>;
	selectedRewardGroupId?: string;
	setSelectedRewardGroupId: Dispatch<SetStateAction<string | undefined>>;
	selectedRewardSkus: SkuQuantity[];
	setSelectedRewardSkus: Dispatch<SetStateAction<SkuQuantity[]>>;
	showPromotionOptions: boolean;
	setShowPromotionOptions: Dispatch<SetStateAction<boolean>>;
}

export const FreeGiftInteractionContext = createContext<FreeGiftInteractionContextValue | null>(
	null
);

export const useFreeGiftInteraction = (): FreeGiftInteractionContextValue => {
	const context = useContext(FreeGiftInteractionContext);

	if (!context) {
		throw new Error(
			'useFreeGiftInteraction must be used within a FreeGiftInteractionContext.Provider'
		);
	}

	return context;
};
